webpackJsonp([8],{

/***/ "YNt2":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var constructQueryForTerms = exports.constructQueryForTerms = function constructQueryForTerms(type, terms, teksti) {
  var query = '\n    query RezultatiQuery($lang: String!, $page: Int, $perpage: Int, $orderby: [String], $order: [String], $search: String, $from: Int, $to: Int, ' + terms.map(function (term) {
    return '$' + term + ': [String]';
  }).join(', ') + ') {\n      ' + type + '(lang: $lang, page: $page, perpage: $perpage, orderby: $orderby, order: $order, search: $search, from: $from, to: $to, ' + terms.map(function (term) {
    return term + ': $' + term;
  }).join(', ') + ') {\n        page\n        perpage\n        total\n        ' + constructTermsPartial(terms, ['slug', 'name', 'count']) + '\n        posts {\n          _id\n          path\n          title\n          date_created\n          date_modified\n          acf\n          ' + constructTermsPartial(terms, ['slug', 'name']) + '\n        }\n      }\n      ' + constructTekstiPartial(teksti) + '\n    }\n  ';
  return query;
};

var constructQueryForPostTerms = exports.constructQueryForPostTerms = function constructQueryForPostTerms(terms, teksti) {
  var query = '\n    query PostQuery($lang: String!, $postId: [Int]!) {\n      page(lang: $lang, _id: $postId) {\n        path\n        date_created\n        date_modified\n        title\n        content\n        acf\n        ' + constructTermsPartial(terms) + '\n      }\n      ' + constructTekstiPartial(teksti) + '\n    }\n  ';

  return query;
};

var constructTermsPartial = exports.constructTermsPartial = function constructTermsPartial(terms) {
  var keys = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ['name'];

  if (terms && Array.isArray(terms) && terms.length > 0) {
    return '\n      terms {\n        ' + terms.map(function (term) {
      return '\n        ' + term + ' {\n          ' + keys.map(function (key) {
        return key;
      }).join('\n') + '\n        }\n      ';
    }).join('') + '\n      }\n    ';
  }
  return '';
};

var constructTekstiPartial = exports.constructTekstiPartial = function constructTekstiPartial(teksti) {
  if (teksti && Array.isArray(teksti) && teksti.length > 0) {
    return '\n      teksti(lang: $lang, _id: [' + teksti.map(function (id) {
      return '"' + id + '"';
    }).join(', ') + ']) {\n        _id\n        text\n      }\n    ';
  }
  return '';
};

var constructTermsObj = exports.constructTermsObj = function constructTermsObj(terms) {
  var data = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  var obj = {};
  terms.forEach(function (term) {
    obj[term] = data && data[term] ? data[term] : null;
  });
  return obj;
};

/***/ }),

/***/ "cVUl":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n    query JaunumiRakstsQuery($lang: String!, $postId: [Int]!, $orderby: [String], $order: [String]) {\n      page(lang: $lang, _id: $postId, orderby: $orderby, order: $order,) {\n        title\n        content\n        date_created\n        date_modified\n        acf\n        ', '\n        galerija {\n          thumb(size: "large") {\n            url\n          }\n          alt\n          caption\n        }\n      }\n      ', '\n    }\n  '], ['\n    query JaunumiRakstsQuery($lang: String!, $postId: [Int]!, $orderby: [String], $order: [String]) {\n      page(lang: $lang, _id: $postId, orderby: $orderby, order: $order,) {\n        title\n        content\n        date_created\n        date_modified\n        acf\n        ', '\n        galerija {\n          thumb(size: "large") {\n            url\n          }\n          alt\n          caption\n        }\n      }\n      ', '\n    }\n  ']);

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _reactApollo = __webpack_require__("3zLD");

var _graphqlTag = __webpack_require__("tlQw");

var _graphqlTag2 = _interopRequireDefault(_graphqlTag);

var _constructQuery = __webpack_require__("YNt2");

var _pages = __webpack_require__("04qB");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var withRakstsJaunumiQuery = function withRakstsJaunumiQuery(_ref) {
  var _ref$terms = _ref.terms,
      terms = _ref$terms === undefined ? ['post_tag'] : _ref$terms,
      teksti = _ref.teksti,
      lang = _ref.lang,
      _ref$orderby = _ref.orderby,
      orderby = _ref$orderby === undefined ? 'date_created' : _ref$orderby,
      _ref$order = _ref.order,
      order = _ref$order === undefined ? 'desc' : _ref$order;

  var QUERY = (0, _graphqlTag2.default)(_templateObject, (0, _constructQuery.constructTermsPartial)(terms, ['slug', 'name']), (0, _constructQuery.constructTekstiPartial)(teksti));

  var queryOptions = {
    options: function options(_ref2) {
      var lang = _ref2.lang,
          postId = _ref2.postId,
          init_page = _ref2.init_page,
          skip = _ref2.skip;


      // console.log(postId)
      // console.log(init_page)

      return {
        fetchPolicy: 'cache-first',
        skip: skip || false,
        variables: {
          lang: lang || 'lv',
          orderby: orderby,
          order: order,
          postId: init_page.rewrite_id ? init_page.rewrite_id : postId
        }
      };
    },
    props: function props(_props) {
      var _props$data = _props.data,
          loading = _props$data.loading,
          lang = _props$data.variables.lang,
          page = _props$data.page,
          teksti = _props$data.teksti,
          rest = _objectWithoutProperties(_props$data, ['loading', 'variables', 'page', 'teksti']);

      return {
        loading: loading,
        data: {
          lang: lang,
          teksti: teksti,
          page: Array.isArray(page) && page.length > 0 ? page[0] : page
        }
      };
    }
  };

  var JaunumiDefault = function JaunumiDefault(props) {
    return props.loading ? null : _react2.default.createElement(_pages.RakstsJaunumi, { data: props.data, lang: props.lang, path: props.history.location.pathname });
  };

  return (0, _reactApollo.compose)((0, _reactApollo.graphql)(QUERY, queryOptions))(JaunumiDefault);
};

exports.default = withRakstsJaunumiQuery;

/***/ }),

/***/ "n2cJ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__("GiK3");

var _react2 = _interopRequireDefault(_react);

var _withRakstsJaunumiQuery = __webpack_require__("cVUl");

var _withRakstsJaunumiQuery2 = _interopRequireDefault(_withRakstsJaunumiQuery);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PostDefault = function PostDefault(props) {
  var PageWithRakstsJaunumi = (0, _withRakstsJaunumiQuery2.default)({
    lang: props.lang,
    teksti: ['publicets', 'atjaunots', 'no', 'ieprieksejais_slaids', 'nakamais_slaids', 'sis_ir_pirmais_slaids', 'sis_ir_pedejais_slaids', 'iet_uz_slaidu', 'apskatit_attelu_originalizmera']
  });
  return _react2.default.createElement(PageWithRakstsJaunumi, props);
};

exports.default = PostDefault;

/***/ })

});


// WEBPACK FOOTER //
// PostDefault.c111e44ee63b2f8fcb60.js